module.exports = {
      id: "google-g-usage",
      viewBox: "0 0 46 46",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#google-g",
      toString: function () {
        return this.url;
      }
    }